import {
  useBookingModuleStore,
  useCalendarRoot,
  useWorkforceProfilesDataIfAvailable
} from "PFApp/booking/store";
import { CalendarMetric } from "PFApp/booking/types";
import { CalendarRoot } from "PFApp/booking/types/calendar_root";
import { isWorkforceProfiles } from "PFApp/booking/utils/calendar_root.utils";
import useIsFeatureEnabled from "PFCore/helpers/use_is_feature_enabled";
import { FeatureFlag } from "PFTypes";
import { useEffect } from "react";

export const useResetCalendarMetric = () => {
  const showUtilizationMetrics = useIsFeatureEnabled()(FeatureFlag.ShowUtilization);
  const DEFAULT_METRIC = showUtilizationMetrics ? CalendarMetric.Utilization : CalendarMetric.TotalHours;

  const calendarRoot = useCalendarRoot();
  const { metric } = useWorkforceProfilesDataIfAvailable("metric");
  const workforceActions = useBookingModuleStore((state) =>
    isWorkforceProfiles(calendarRoot) ? state.actions[CalendarRoot.WorkforceProfiles] : null
  );

  useEffect(() => {
    if (metric === CalendarMetric.Utilization && !showUtilizationMetrics) {
      workforceActions?.setMetric(DEFAULT_METRIC);
    }
  }, [showUtilizationMetrics]);
};
